<template>
  <div>
    <div class="page-header header-filter" id="backgroundImage" style="background-image: url('document-428335_1280.jpg')">
      <div class="container">

        <div class="row title-row">
          <div class="col-md-10">
            <h1 class="title responsive-title">{{ $t('header.primary') }}</h1>
            <h2 class="responsive-title">{{ $t('header.secondary') }}</h2>
            <h4>{{ $t('header.description') }}</h4>
            <br>
            <span class="btn btn-danger btn-raised btn-lg main-btn" v-scroll-to="'#formContainer'">{{ $t('ui.generateBtn')
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="main main-raised">
      <div class="container" id="formContainer" ref="formContainer">
        <div class="section">
          <div class="row">
            <div class="col-md-3 ml-auto mr-auto">
              <div id="contractTypeContainer">
                <h3>{{ $t('form.contractType') }}:</h3>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="radio" name="contractType" id="contractType1" value="1"
                      v-model="contractOptions.contractType">
                    {{ $t('form.contractOfEmployment') }}
                    <span class="circle">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="radio" name="contractType" id="contractType2" value="2"
                      v-model="contractOptions.contractType"> {{ $t('form.contractOfWork') }}
                    <span class="circle">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="radio" name="contractType" id="contractType3" value="3"
                      v-model="contractOptions.contractType">{{ $t('form.contractB2B') }}
                    <span class="circle">
                    <span class="check"></span>
                    </span>
                  </label>
                </div>
              </div>
              <form>
                <div id="employeeContainer">
                  <h3>{{ employeeHeader }}:</h3>
                  <div class="form-group has-default bmd-form-group">
                    <input type="text" class="form-control" :placeholder="$t('form.nameAndSurname') + '*'"
                      v-model="employee.name" autocomplete="name" v-validate="'required'" data-vv-name="employee.name"
                      data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employee.name') }}</span>
                  </div>

                  <div class="form-group has-default bmd-form-group" v-if="contractOptions.contractType == 3">
                    <input type="text" class="form-control" :placeholder="$t('form.contractorComanyName') + '*'"
                      v-model="employee.companyName" autocomplete="organization" v-validate="'required'"
                      data-vv-name="employee.companyName" data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employee.companyName') }}</span>
                  </div>
                  <div class="form-group has-default bmd-form-group" v-if="contractOptions.contractType == 3">
                    <input type="tel" class="form-control" :placeholder="$t('form.companyTaxNr')" v-mask="'##########'"
                      v-model="employee.nip" v-validate="'required|length:10'" data-vv-name="employee.nip" data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employee.nip') }}</span>
                  </div>
                  <div class="form-group has-default bmd-form-group">
                    <input type="text" class="form-control" :placeholder="$t('form.address') + '*'"
                      v-model="employee.address" autocomplete="street-address" v-validate="'required'"
                      data-vv-name="employee.address" data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employee.address') }}</span>
                  </div>
                  <div class="form-group has-default bmd-form-group">
                    <input type="text" class="form-control" :placeholder="$t('form.city') + '*'" v-model="employee.city"
                      autocomplete="locality" v-validate="'required'" data-vv-name="employee.city" data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employee.city') }}</span>
                  </div>
                  <div class="form-group has-default bmd-form-group">
                    <input type="text" class="form-control" :placeholder="$t('form.postalCode') + '*'"
                      v-model="employee.postalCode" autocomplete="postal-code" v-mask="'##-###'"
                      v-validate="'required|length:6'" data-vv-name="employee.postalCode" data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employee.postalCode') }}</span>
                  </div>
                </div>
              </form>
              <form>
                <div id="employerContainer">
                  <h3>{{ employerHeader }}:</h3>
                  <div class="form-group has-default bmd-form-group">
                    <input type="text" class="form-control" :placeholder="$t('form.comanyName') + '*'"
                      v-model="employer.name" autocomplete="organization" v-validate="'required'"
                      data-vv-name="employer.name" data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employer.name') }}</span>
                  </div>
                  <div class="form-group has-default bmd-form-group">
                    <input type="tel" class="form-control" :placeholder="$t('form.companyTaxNr') + '*'"
                      v-mask="'##########'" v-model="employer.nip" v-validate="'required|length:10'"
                      data-vv-name="employer.nip" data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employer.nip') }}</span>
                  </div>
                  <div class="form-group has-default bmd-form-group">
                    <input type="text" class="form-control" :placeholder="$t('form.address') + '*'"
                      v-model="employer.address" autocomplete="street-address" v-validate="'required'"
                      data-vv-name="employer.address" data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employer.address') }}</span>
                  </div>
                  <div class="form-group has-default bmd-form-group">
                    <input type="text" class="form-control" :placeholder="$t('form.city') + '*'" v-model="employer.city"
                      autocomplete="locality" v-validate="'required'" data-vv-name="employer.city" data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employer.city') }}</span>
                  </div>
                  <div class="form-group has-default bmd-form-group">
                    <input type="text" class="form-control" :placeholder="$t('form.postalCode') + '*'"
                      v-model="employer.postalCode" v-mask="'##-###'" autocomplete="postal-code"
                      v-validate="'required|length:6'" data-vv-name="employer.postalCode" data-vv-as=" ">
                    <span class="text-danger">{{ errors.first('employer.postalCode') }}</span>
                  </div>
                </div>
              </form>
              <div id="terminationTimeContainer">
                <h3>{{ $t('form.noticePeriod') }}:</h3>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="radio" name="terminationTime" id="terminationTime1" value="1"
                      v-model="contractOptions.terminationTime">
                    {{ $t('form.noticePeriodOneMonth') }}
                    <span class="circle">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="radio" name="terminationTime" id="terminationTime2" value="2"
                      v-model="contractOptions.terminationTime"> {{ $t('form.noticePeriodThreeMonths') }}
                    <span class="circle">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="radio" name="terminationTime" id="terminationTime3" value="3"
                      v-model="contractOptions.terminationTime">{{ $t('form.noticePeriodOther') }}:
                    <span class="circle">
                      <span class="check"></span>
                    </span>
                    <input type="text" class="form-control" :placeholder="$t('form.noticePeriodPlaceholder') + '*'"
                      v-validate="'required'" data-vv-name="contractOptions.customTerminationTime" data-vv-as=" "
                      v-model="contractOptions.customTerminationTime" v-if="contractOptions.terminationTime == 3">
                  </label>
                </div>
                <span class="text-danger">{{ errors.first('contractOptions.customTerminationTime') }}</span>
              </div>
              <div id="optionsContainer">
                <h3>{{ $t('form.additionalInfo') }}:</h3>
                <div class="form-group has-default bmd-form-group">
                  <input type="text" class="form-control" :placeholder="$t('form.city') + '*'"
                    v-model="contractOptions.city" autocomplete="locality" v-validate="'required'"
                    data-vv-name="contractOptions.city" data-vv-as=" ">
                  <span class="text-danger">{{ errors.first('contractOptions.city') }}</span>
                </div>
                <div class="form-group has-default bmd-form-group">
                  <label class="label-control bmd-label-static" for="terminationDate">{{ $t('form.dateOfNotice')
                  }}*</label>
                  <datepicker :bootstrap-styling="true" :language="pl" :disabledDates="disabledDates"
                    v-model="contractOptions.terminationDate" name="terminationDate" input-class="form-control">
                  </datepicker>
                </div>
                <div class="form-group has-default bmd-form-group">
                  <label class="label-control bmd-label-static" for="contractDate">{{ $t('form.contractDate') }}*</label>
                  <datepicker :bootstrap-styling="true" :language="pl" :disabledDates="contractDateDisabledValues"
                    v-model="contractOptions.contractDate" name="contractDate" input-class="form-control"></datepicker>
                </div>
                <div class="form-group has-default bmd-form-group">
                  <input type="text" class="form-control" :placeholder="$t('form.contractNumber')"
                    v-model="contractOptions.contractNumber">
                </div>
              </div>
            </div>
            <div class="col-md-9 ml-auto mr-auto">
              <div class="alert alert-danger" v-if="formHasErrors">
                <div class="container">
                  <div class="alert-icon">
                    <i class="material-icons">error_outline</i>
                  </div>{{ $t('form.validationMsg') }}
                </div>
              </div>

              <div class="card" ref="pdfContent">
                <ContractOfEmployment v-if="contractOptions.contractType == 1" v-bind:contractOptions="contractOptions"
                  v-bind:employer="employer" v-bind:employee="employee" />
                <ContractWork v-else-if="contractOptions.contractType == 2" v-bind:contractOptions="contractOptions"
                  v-bind:employer="employer" v-bind:employee="employee" />
                <ContractB2B v-else-if="contractOptions.contractType == 3" v-bind:contractOptions="contractOptions"
                  v-bind:employer="employer" v-bind:employee="employee" />
              </div>
              <div class="text-center">
                <button @click="downloadPdf" class="btn btn-primary">{{ $t('ui.downloadBtn') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ContractOfEmployment from "./ContractOfEmployment.vue";
import ContractWork from "./ContractWork.vue";
import ContractB2B from "./ContractB2B.vue";
import Datepicker from "vuejs-datepicker";
import { en, pl } from "vuejs-datepicker/dist/locale";
import { mask } from "vue-the-mask";
import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import VeeValidatePl from "vee-validate/dist/locale/pl";
import VeeValidateUk from "vee-validate/dist/locale/uk";


const cookieLifetime = '1d';

var VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

Vue.use(VeeValidate, {
  events: ""
});
Validator.localize("pl", VeeValidatePl);

export default {
  created: function () {
    document.title = "Szybkie Wypo - Generator wypowiedzeń";
  },
  name: "HelloWorld",
  props: {
    msg: String
  },
  directives: { mask },
  methods: {
    downloadPdf: function () {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.formHasErrors = false;
          var pdfMake = require("pdfmake/build/pdfmake.js");
          var docDefinition;

          if (pdfMake.vfs == undefined) {
            var pdfFonts = require("pdfmake/build/vfs_fonts.js");
            pdfMake.vfs = pdfFonts.pdfMake.vfs;
          }

          switch (parseInt(this.contractOptions.contractType)) {
            case 2: {
              docDefinition = require("../pdfTemplates/ContractWorkTemplate.js");
              break;
            }
            case 3: {
              docDefinition = require("../pdfTemplates/ContractB2BTemplate.js");
              break;
            }
            default: {
              docDefinition = require("../pdfTemplates/ContractOfEmploymentTemplate.js");
              break;
            }
          }
          pdfMake
            .createPdf(
              docDefinition.default.prepareContent(
                this.contractOptions,
                this.employee,
                this.employer
              )
            )
            .download("wypowiedzenie.pdf");            
        } else {
          this.formHasErrors = true;
          VueScrollTo.scrollTo(this.$refs.formContainer);
        }
      });
    }
  },  
  data: function () {
    return {
      disabledDates: {
        to: new Date(Date.now() - 1209600000),
        from: new Date(Date.now() + 1209600000)
      },      
      formHasErrors: false,
      en: en,
      pl: pl,
      contractOptions: {
        contractType: 1,
        terminationDate: new Date(),
        city: "",
        contractDate: new Date(),
        terminationTime: 1,
        customTerminationTime: null,
        contractNumber: ""
      },
      employee: {
        name: "",
        companyName: "",
        nip: null,
        address: "",
        city: "",
        postalCode: null
      },
      employer: {
        name: "",
        nip: null,
        address: "",
        city: "",
        postalCode: ""
      }
    };
  },
  computed: {
    employeeHeader: function () {
      return this.contractOptions.contractType != 1
        ? this.$t('form.contractor')
        : this.$t('form.employee');
    },
    employerHeader: function () {
      return this.contractOptions.contractType != 1
        ? this.$t('form.customer')
        : this.$t('form.employer');
    },
    contractDateDisabledValues: function () {
      return {
        from: this.contractOptions.terminationDate
      };
    },
   
  },

  watch: {
    '$i18n.locale': function (newVal) {
      if (newVal == "ua") {
        Validator.localize("uk", VeeValidateUk);
      }
      else {
        Validator.localize("pl", VeeValidatePl);
      }
    }
  },
  components: {
    ContractOfEmployment,
    ContractWork,
    ContractB2B,
    Datepicker
  }
};
</script>

<style scoped>
.main-btn {
  background-color: #ce2114;
  border-color: #ce2114;
}

@media (max-width: 1000px) {
  .page-header {
    height: 130vh;
  }

  h1.responsive-title {
    font-size: 1.7rem;
  }

  h2.responsive-title {
    font-size: 1.4rem;
  }
}

.vdp-datepicker {
  margin-top: 10px;
}
</style>
